import { render } from "./MessageEdit.vue?vue&type=template&id=5858f0d1&scoped=true"
import script from "./MessageEdit.vue?vue&type=script&lang=js"
export * from "./MessageEdit.vue?vue&type=script&lang=js"

import "./MessageEdit.vue?vue&type=style&index=0&id=5858f0d1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5858f0d1"]])

export default __exports__